import { Component, Input } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";

import { CategoryDTO } from "src/app/models/Categories/categoryDTO";
import { CategoryElementDTO } from "src/app/models/Categories/categoryElementDTO";

@Component({
  selector: "app-categories",
  templateUrl: "./categories.component.html",
  styleUrls: ["./categories.component.scss"],
})
export class CategoriesComponent {
  public locale: string = localStorage.getItem("locale");

  _categories: CategoryDTO[];

  @Input() selectedCategories: CategoryElementDTO[];
  @Input() set categories(categoryList: CategoryDTO[]) {
    if (categoryList) {
      this._categories = this.sortByMandatory(categoryList);
      this.setCategoriesForm(this._categories);
    }
  }
  @Input() formArray: FormArray;

  constructor(private fb: FormBuilder) {}

  sortByMandatory(categories: CategoryDTO[]): CategoryDTO[] {
    return categories.slice().sort((x, y) => {
      return x.mandatory === y.mandatory ? 0 : x.mandatory ? -1 : 1;
    });
  }

  setCategoriesForm(categories: CategoryDTO[]): void {
    categories.forEach((category) => {
      const selectedCategory = this.getSelectedCategory(
        category,
        this.selectedCategories
      );
      this.formArray.push(
        this.fb.group({
          [category.code]: [
            selectedCategory ? selectedCategory.code : "",
            category.mandatory ? Validators.required : [],
          ],
        })
      );
    });
  }

  getSelectedCategory(
    category: CategoryDTO,
    selectedCategories: CategoryElementDTO[]
  ): CategoryDTO {
    if (!selectedCategories) {
      return;
    }
    return selectedCategories.find(
      (selCat) => selCat.categoryCode === category.code
    );
  }

  getCategoryElementsList(categoryControl: FormGroup): CategoryElementDTO[] {
    const [categoryCode] = Object.keys(categoryControl.controls);
    const category = this.getCategory(this._categories, categoryCode);
    return category.categoryElements;
  }

  getFormLabel(categoryControl: FormGroup): string {
    const [categoryCode] = Object.keys(categoryControl.controls);
    const category = this.getCategory(this._categories, categoryCode);
    return category.description;
  }

  getRequiredIndication(categoryControl: FormGroup): boolean {
    const [categoryCode] = Object.keys(categoryControl.controls);
    const category = this.getCategory(this._categories, categoryCode);
    return category.mandatory;
  }

  getCategory(categories: CategoryDTO[], categoryCode: string): CategoryDTO {
    return categories.find((category) => category.code === categoryCode);
  }

  getFormControlName(categoryControl: FormGroup): string {
    const [categoryCode] = Object.keys(categoryControl.controls);
    return categoryCode;
  }

  clearFormControl(categoryControl: FormGroup): void {
    const [categoryCode] = Object.keys(categoryControl.controls);
    categoryControl.controls[categoryCode].setValue("");
    this.formArray.markAsDirty();
  }
}
